import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=27a7ec0f&scoped=true&"
import script from "./ValidationErrors.vue?vue&type=script&lang=js&"
export * from "./ValidationErrors.vue?vue&type=script&lang=js&"
import style0 from "./ValidationErrors.vue?vue&type=style&index=0&id=27a7ec0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7ec0f",
  null
  
)

export default component.exports